// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_unification_debug = require("../mm-utils/MM_unification_debug.res.js");

function makeInitialState() {
  return {
          expanded: false,
          expandedSrcs: [],
          allSrcsExpanded: false
        };
}

function toggleExpanded(st) {
  return {
          expanded: !st.expanded,
          expandedSrcs: st.expandedSrcs,
          allSrcsExpanded: st.allSrcsExpanded
        };
}

function toggleAllSrcsExpanded(st) {
  return {
          expanded: st.expanded,
          expandedSrcs: st.expandedSrcs,
          allSrcsExpanded: !st.allSrcsExpanded
        };
}

var validProofIcon = React.createElement("span", {
      style: {
        color: "green",
        fontWeight: "bold"
      },
      title: "This is a valid proof"
    }, "\u2713");

function propsInnerAreSame(a, b) {
  return a.showUnprovedOnly === b.showUnprovedOnly;
}

function rndExpandCollapseIcon(expand, visible, onClick) {
  return React.createElement("span", {
              style: {
                cursor: "pointer",
                fontSize: "13px",
                opacity: visible ? "1.0" : "0.0"
              },
              onClick: (function (param) {
                  onClick();
                })
            }, expand ? "\u229E" : "\u229F");
}

var ProofNodeDtoCmp = Caml_module.init_mod([
      "MM_cmp_proof_node.res",
      89,
      4
    ], {
      TAG: "Module",
      _0: [[
          "Function",
          "make"
        ]]
    });

var make = React.memo((function (param) {
        var showUnprovedOnly = param.showUnprovedOnly;
        var getFrmLabelBkgColor = param.getFrmLabelBkgColor;
        var frmExprToStr = param.frmExprToStr;
        var exprToReElem = param.exprToReElem;
        var exprToStr = param.exprToStr;
        var nodeIdxToLabel = param.nodeIdxToLabel;
        var isRootStmt = param.isRootStmt;
        var nodeIdx = param.nodeIdx;
        var tree = param.tree;
        var match = React.useState(makeInitialState);
        var setState = match[1];
        var state = match[0];
        var node = tree.nodes[nodeIdx];
        var getParents = function () {
          if (node.parents.length !== 0) {
            return node.parents;
          }
          var src = node.proof;
          if (src !== undefined) {
            return [src];
          } else {
            return [];
          }
        };
        var parents = getParents();
        var actToggleExpanded = function () {
          setState(toggleExpanded);
        };
        var actToggleAllSrcsExpanded = function () {
          setState(function (st) {
                var st$1 = toggleAllSrcsExpanded(st);
                if (parents.length > 0) {
                  if (st$1.allSrcsExpanded) {
                    return {
                            expanded: true,
                            expandedSrcs: Belt_Array.range(0, parents.length - 1 | 0),
                            allSrcsExpanded: st$1.allSrcsExpanded
                          };
                  } else {
                    return {
                            expanded: st$1.expanded,
                            expandedSrcs: [],
                            allSrcsExpanded: st$1.allSrcsExpanded
                          };
                  }
                } else {
                  return st$1;
                }
              });
        };
        var actToggleSrcExpanded = function (srcIdx) {
          setState(function (__x) {
                if (__x.expandedSrcs.includes(srcIdx)) {
                  return {
                          expanded: __x.expanded,
                          expandedSrcs: __x.expandedSrcs.filter(function (i) {
                                return i !== srcIdx;
                              }),
                          allSrcsExpanded: __x.allSrcsExpanded
                        };
                } else {
                  return {
                          expanded: __x.expanded,
                          expandedSrcs: __x.expandedSrcs.concat([srcIdx]),
                          allSrcsExpanded: __x.allSrcsExpanded
                        };
                }
              });
        };
        var getColorForLabel = function (nodeIdx) {
          if (isRootStmt(nodeIdx)) {
            return "black";
          } else {
            return "lightgrey";
          }
        };
        var rndCollapsedArgs = function (args, srcIdx) {
          return React.createElement("span", {
                      style: {
                        cursor: "pointer"
                      },
                      onClick: (function (param) {
                          actToggleSrcExpanded(srcIdx);
                        })
                    }, "( ", args.map(function (arg, i) {
                          return React.createElement("span", {
                                      key: String(i),
                                      style: {
                                        color: getColorForLabel(arg)
                                      }
                                    }, nodeIdxToLabel(arg) + " ");
                        }), " )");
        };
        var rndErr = function (err, asrtLabel) {
          return React.createElement("pre", {
                      style: {
                        color: "red",
                        margin: "0px"
                      }
                    }, MM_unification_debug.unifErrToStr(err, exprToStr, (function (__x) {
                            return frmExprToStr(asrtLabel, __x);
                          })));
        };
        var isAsrtWithoutHyps = function (src) {
          if (typeof src !== "object") {
            return false;
          }
          switch (src.TAG) {
            case "Hypothesis" :
                return false;
            case "Assertion" :
                return src.args.length === 0;
            case "AssertionWithErr" :
                var args = src.args;
                var tmp = src.err;
                if (typeof tmp !== "object") {
                  return args.length === 0;
                }
                switch (tmp.TAG) {
                  case "DisjCommonVar" :
                  case "Disj" :
                  case "UnprovedFloating" :
                      return args.length === 0;
                  default:
                    return false;
                }
            
          }
        };
        var isNodeProved = function (argIdx) {
          return Core__Option.isSome(tree.nodes[argIdx].proof);
        };
        var rndExpandedArgs = function (args, srcIdx) {
          var src = parents[srcIdx];
          var tmp;
          tmp = typeof src !== "object" || src.TAG !== "AssertionWithErr" ? null : React.createElement("tr", undefined, React.createElement("td", undefined, rndErr(src.err, src.label)));
          return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", {
                              key: "c-args"
                            }, React.createElement("td", undefined, rndCollapsedArgs(args, srcIdx))), tmp, isAsrtWithoutHyps(src) ? React.createElement("tr", {
                                key: "-exp"
                              }, React.createElement("td", undefined, "This assertion doesn't have hypotheses.")) : args.filter(function (arg) {
                                  if (showUnprovedOnly) {
                                    return !isNodeProved(arg);
                                  } else {
                                    return true;
                                  }
                                }).map(function (arg, argIdx) {
                                return React.createElement("tr", {
                                            key: String(argIdx) + "-exp"
                                          }, React.createElement("td", undefined, React.createElement(ProofNodeDtoCmp.make, {
                                                    tree: tree,
                                                    nodeIdx: arg,
                                                    isRootStmt: isRootStmt,
                                                    nodeIdxToLabel: nodeIdxToLabel,
                                                    exprToStr: exprToStr,
                                                    exprToReElem: exprToReElem,
                                                    frmExprToStr: frmExprToStr,
                                                    getFrmLabelBkgColor: getFrmLabelBkgColor,
                                                    showUnprovedOnly: showUnprovedOnly
                                                  })));
                              })));
        };
        var rndStatusIconForStmt = function (node) {
          return React.createElement("span", {
                      style: {
                        color: "green",
                        fontWeight: "bold",
                        visibility: Belt_Option.isSome(node.proof) ? "visible" : "hidden"
                      },
                      title: "This is proved"
                    }, "\u2713");
        };
        var rndStatusIconForSrc = function (src) {
          if (typeof src !== "object") {
            return validProofIcon;
          }
          switch (src.TAG) {
            case "Hypothesis" :
                return validProofIcon;
            case "Assertion" :
                var allArgsAreProved = src.args.every(function (arg) {
                      return Belt_Option.isSome(tree.nodes[arg].proof);
                    });
                if (allArgsAreProved) {
                  return validProofIcon;
                } else {
                  return null;
                }
            case "AssertionWithErr" :
                return React.createElement("span", {
                            style: {
                              color: "red",
                              cursor: "pointer",
                              fontWeight: "bold"
                            }
                          }, "\u2717");
            
          }
        };
        var rndSrcs = function () {
          if (parents.length === 0) {
            return "Sources are not set.";
          } else {
            return React.createElement("table", undefined, React.createElement("tbody", undefined, parents.map(function (src, srcIdx) {
                                var key = String(srcIdx);
                                if (typeof src !== "object") {
                                  return React.createElement("tr", {
                                              key: key
                                            }, React.createElement("td", {
                                                  style: {
                                                    verticalAlign: "top"
                                                  }
                                                }, rndStatusIconForSrc(src)), React.createElement("td", undefined, "VarType"), React.createElement("td", undefined, null));
                                }
                                switch (src.TAG) {
                                  case "Hypothesis" :
                                      return React.createElement("tr", {
                                                  key: key
                                                }, React.createElement("td", {
                                                      style: {
                                                        verticalAlign: "top"
                                                      }
                                                    }, rndStatusIconForSrc(src)), React.createElement("td", undefined, "Hyp " + src.label), React.createElement("td", undefined, null));
                                  case "Assertion" :
                                  case "AssertionWithErr" :
                                      break;
                                  
                                }
                                var label = src.label;
                                var args = src.args;
                                var tmp = {
                                  borderRadius: "3px"
                                };
                                var tmp$1 = getFrmLabelBkgColor(label);
                                if (tmp$1 !== undefined) {
                                  tmp.backgroundColor = tmp$1;
                                }
                                return React.createElement("tr", {
                                            key: key
                                          }, React.createElement("td", {
                                                style: {
                                                  verticalAlign: "top"
                                                }
                                              }, rndStatusIconForSrc(src)), React.createElement("td", {
                                                style: {
                                                  verticalAlign: "top"
                                                }
                                              }, rndExpandCollapseIcon(!state.expandedSrcs.includes(srcIdx), parents.length !== 0, (function () {
                                                      actToggleSrcExpanded(srcIdx);
                                                    })), React.createElement("span", {
                                                    style: tmp
                                                  }, React.createElement("i", undefined, label))), React.createElement("td", undefined, state.expandedSrcs.includes(srcIdx) ? rndExpandedArgs(args, srcIdx) : rndCollapsedArgs(args, srcIdx)));
                              })));
          }
        };
        var rndNode = function () {
          return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndStatusIconForStmt(node)), React.createElement("td", {
                                  style: {
                                    color: getColorForLabel(nodeIdx)
                                  }
                                }, rndExpandCollapseIcon(!state.expanded, parents.length !== 0, actToggleExpanded), nodeIdxToLabel(nodeIdx) + ":"), React.createElement("td", {
                                  style: {
                                    minWidth: "500px"
                                  }
                                }, exprToReElem(tree.nodes[nodeIdx].expr), rndExpandCollapseIcon(!state.allSrcsExpanded, parents.length !== 0, actToggleAllSrcsExpanded))), state.expanded ? React.createElement("tr", undefined, React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, rndSrcs())) : null));
        };
        return rndNode();
      }), propsInnerAreSame);

Caml_module.update_mod({
      TAG: "Module",
      _0: [[
          "Function",
          "make"
        ]]
    }, ProofNodeDtoCmp, {
      make: make
    });

function MM_cmp_proof_node(props) {
  return React.createElement(ProofNodeDtoCmp.make, {
              tree: props.tree,
              nodeIdx: props.nodeIdx,
              isRootStmt: props.isRootStmt,
              nodeIdxToLabel: props.nodeIdxToLabel,
              exprToStr: props.exprToStr,
              exprToReElem: props.exprToReElem,
              frmExprToStr: props.frmExprToStr,
              getFrmLabelBkgColor: props.getFrmLabelBkgColor,
              showUnprovedOnly: props.showUnprovedOnly
            });
}

var make$1 = MM_cmp_proof_node;

exports.make = make$1;
/* validProofIcon Not a pure module */
